import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';

export const DIALOG_TYPE_ASSET = 'ASSET_DIALOG';
export const VehicleDialogOrigin = {
  Banner: 'banner',
  AddAccount: 'add-account',
  EditAccount: 'edit-account',
} as const;
export type VehicleDialogOrigin = (typeof VehicleDialogOrigin)[keyof typeof VehicleDialogOrigin];

type ShowVehicleDialogOptions = {
  linkTo?: string;
  onBackToSource?: () => void;
  dialogOrigin?: VehicleDialogOrigin;
};

export const showRealEstateDialog = (linkTo?: string) =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE_ASSET,
      id: DIALOG_TYPE_ASSET,
      allowNesting: true,
      props: ImmutableMap({
        assetType: 'realEstate',
        linkTo,
      }),
    }),
  );
export const showVehicleDialog = ({ linkTo, onBackToSource, dialogOrigin }: ShowVehicleDialogOptions = {}) =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE_ASSET,
      id: DIALOG_TYPE_ASSET,
      allowNesting: true,
      props: ImmutableMap({
        assetType: 'vehicle',
        linkTo,
        onBackToSource,
        dialogOrigin,
      }),
    }),
  );
